import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Navbar: React.FC = () => {
  const location = useLocation();
  const { language, toggleLanguage, isTransitioning, isAutoDetected, resetToAuto } = useLanguage();

  const navContent = {
    en: {
      home: 'Home',
      faqs: 'FAQs',
      about: 'About'
    },
    ja: {
      home: 'ホーム',
      faqs: 'よくある質問',
      about: 'について'
    }
  };

  const t = navContent[language];

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-logo">
            <div className="moon-logo"></div>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <span>ProjectLumina</span>
            </Link>
          </div>
          <div className="navbar-links">
            <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>{t.home}</Link>
            <Link to="/faqs" className={`nav-link ${location.pathname === '/faqs' ? 'active' : ''}`}>{t.faqs}</Link>
            <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>{t.about}</Link>
            <div className="language-toggle-container">
              <button
                className={`language-toggle ${isTransitioning ? 'transitioning' : ''} ${isAutoDetected ? 'auto-detected' : ''}`}
                onClick={toggleLanguage}
                aria-label={`Toggle language${isAutoDetected ? ' (auto-detected)' : ''}`}
                disabled={isTransitioning}
                title={isAutoDetected ? 'Language auto-detected from your browser settings' : 'Language manually selected'}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12.87 15.07L10.33 12.56L10.36 12.53C12.1 10.59 13.34 8.36 14.07 6H17V4H10V2H8V4H1V6H12.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8H4.69C5.42 9.63 6.42 11.17 7.67 12.56L2.58 17.58L4 19L9 14L12.11 17.11L12.87 15.07ZM18.5 10H16.5L12 22H14L15.12 19H19.87L21 22H23L18.5 10ZM15.88 17L17.5 12.67L19.12 17H15.88Z" fill="currentColor"/>
                </svg>
                <span>{isTransitioning ? '...' : (language === 'en' ? 'JP' : 'EN')}</span>
                {isAutoDetected && (
                  <div className="auto-indicator" title="Auto-detected">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="3" fill="currentColor"/>
                    </svg>
                  </div>
                )}
              </button>
              {!isAutoDetected && (
                <button
                  className="reset-auto-button"
                  onClick={resetToAuto}
                  title="Reset to auto-detection"
                  aria-label="Reset to auto-detection"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2V6L16 2L12 2ZM12 18V22L8 18L12 18ZM4.93 4.93L7.76 7.76L6.34 9.18L3.51 6.35L4.93 4.93ZM19.07 19.07L16.24 16.24L17.66 14.82L20.49 17.65L19.07 19.07ZM2 12C2 6.48 6.48 2 12 2V4C7.58 4 4 7.58 4 12S7.58 20 12 20V22C6.48 22 2 17.52 2 12Z" fill="currentColor"/>
                  </svg>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 